module.exports = __webpack_public_path__ + "static/media/CV-Ricardo-Goncalves-2026.34a8e3a4.pdf";